import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Grid,
  TableCell,
  TableRow,
  IconButton,
  FormControlLabel,
  Checkbox,
  Popover,
  Typography,
  Badge,
  Button,
  Card,
  Toolbar,
  Tooltip,
} from "@mui/material";
import { ReactComponent as WarningIcon } from "Assets/Icons/PharmsmartIcon/WarningIcon.svg";
import { ReactComponent as ErrorIcon } from "Assets/Icons/PharmsmartIcon/ErrorIcon.svg";
import { ReactComponent as Error } from "Assets/Icons/Error.svg";
import { ReactComponent as syncIconMain } from "Assets/Icons/PharmsmartIcon/SYNCHome.svg";

import { ReactComponent as AlertIcon } from "Assets/Icons/Alert.svg";
import { ReactComponent as Refresh } from "../../Assets/Icons/refresh.svg";

import { ReactComponent as SyncIcon } from "Assets/Icons/PharmsmartIcon/SYNC.svg";
import { InstallmentDispensingDetail } from "utils/data";
import { ReactComponent as EditIcon } from "Assets/Icons/PharmsmartIcon/EditIcon.svg";
import { ReactComponent as DeleteIcon } from "Assets/Icons/PharmsmartIcon/DeleteIcon.svg";
import { ReactComponent as NoteIcon } from "Assets/Icons/PharmsmartIcon/NoteIcon.svg";
import { ReactComponent as OrderIcon } from "Assets/Icons/PharmsmartIcon/Order.svg";
import { ReactComponent as QuickIcon } from "Assets/Icons/PharmsmartIcon/QuickOrder.svg";
import { ReactComponent as MedicationRequiredIcon } from "Assets/Icons/PharmsmartIcon/MedicationRequired.svg";
import { ReactComponent as Ellipses } from "Assets/Icons/Ellipses.svg";
import { ReactComponent as EllipsesYellow } from "Assets/Icons/EllipsesYellow.svg";
import { getEllipsisName, setLocalStorage } from "utils/generalUtils";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import HtmlTooltipMain from "Components/Common/HtmlTooltipMain";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import Chips from "Components/Common/Chips";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import clsx from "clsx";
import useViewport from "Hooks/useViewport";
import HtmlTooltipOrderdate from "Components/Common/HtmlTooltipOrderdate";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { ReactComponent as OrderShipIcon } from "Assets/Icons/OrderShip.svg";
import { useSelector } from "react-redux";
const useStyle = makeStyles((theme) => ({
  popoverPaper: {
    width: "400px", // Set your desired width here
    borderRadius: "10px !important",
  },
  rsWaringIcon: {
    marginLeft: "196px",
    marginTop: "28px",
    "&>svg": {
      width: "41px",
      height: "38px",
    },
  },
  rsStatusChipText: {
    border: "none !important",
    borderRadius: "2px !important",
    fontSize: "10px !important",
    height: "20px !important",
    marginLeft: "10px !important",
    marginRight: "9px",
    [theme.breakpoints.down(1500)]: {
      marginLeft: "0 !important",
      marginTop: "3px",
    },
  },
  rsOrderDate: {
    "&:hover": {
      lineHeight: "20px",
      cursor: "pointer",
      "&>button": {
        padding: "0px !important",
        "&:hover": {
          backgroundColor: "transparent !important",
          border: `none !important`,
        },
        "&>svg": {
          display: "block",
        },
      },
    },
  },
  rsMediDate: {
    "&>div": {
      width: "150px",
      display: "flex !important",
      "&:hover": {
        lineHeight: "20px",
        cursor: "pointer",
        "&>button": {
          marginLeft: "6px",
          padding: "0px !important",
          "&:hover": {
            backgroundColor: "transparent !important",
            border: `none !important`,
          },
          "&>svg": {
            display: "block",
          },
        },
      },
      "&>div": {
        "&>svg": {
          marginLeft: "4px",
        },
      },
    },
  },
  rseditDateIcon: {
    padding: "0px !important",
    width: "18px",
    height: "18px",
    "&>svg": {
      // marginLeft: 10,
      display: "none",
    },
  },
  rsIconBtn: {
    marginTop: "0px !important",
    borderRadius: "10% !important",
  },
  rsChipsStatusTool: {
    // height: "40px",
    alignItems: "center",
    position: "relative",
    display: "flex",
    //width: "300px !important",
    gap: "3px !important",
    "& .MuiChip-label": {
      lineHeight: "15px",
    },
  },
  rsChipsStatus: {
    height: "29px",
    alignItems: "center",
    position: "relative",
    display: "flex",
    "& .MuiChip-label": {
      lineHeight: "15px",
    },
    "&>div": {
      marginRight: "5px",
    },
  },
  rsPatientInfo: {
    display: "inline-flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    [theme.breakpoints.down(1500)]: {
      display: "inline-flex",
    },
  },
  rsPatientGreyInfo: {
    opacity: "1",
  },
  rsDisabledicon: {
    padding: "10px !important",
    "&:hover": {
      lineHeight: "40px",
      width: "40px",
      cursor: "pointer",
    },
    "&>svg": {
      "&>path": {
        opacity: "0.6 !important",
      },
    },
  },
  hoverAlignBtnTodays: {
    // background: "rgb(123, 192, 68) !important",
    // height: "28px",
    // width: "28px",
    // borderRadius: "5px !important",
    paddingTop: "10px",
    "&>svg": {
      "&>path": {
        fill: "white !important",
        stroke: "white !important",
      },
    },
  },
  hoverAlignBtn: {
    // background: "rgb(123, 192, 68) !important",
    // height: "28px",
    // width: "28px",
    // borderRadius: "5px !important",
    // paddingTop: "10px",
    "&>svg": {
      "&>path": {
        // fill: "white !important",
        // stroke: "white !important",
      },
    },
  },
  rsEllipisisInfo: {
    whiteSpace: "nowrap",
    paddingBottom: "8px !important",
  },
  rsCursorPointer: {
    cursor: "pointer",
  },
  rsHtmlToolTip: {
    cursor: "pointer",
  },
  rsHtmlToolTipchip: {
    // left: "100px !important",
    "&>div": {
      // width: "300px !important",
      backgroundColor: "white !important",
    },
  },
  rsAddress: {
    fontSize: "12px",
    fontWeight: "500",
    marginLeft: "3px",
    fontStyle: "italic",
    // opacity: "0.6",
    "&>div": {
      marginTop: "2px !important",
      "&>svg": {
        width: "20px !important",
        "&>path": {
          fill: "#5A6872  !important",
        },
      },
      "&:hover": {
        opacity: "0.7",
      },
    },
  },
  rsVisibilityIcon: {
    fontSize: "12px",
    fontWeight: "500",
    marginLeft: "3px",
    // opacity: "0.6",
    "&>div": {
      height: "20px !important",
      // marginTop: "6px !important",
      "&>svg": {
        width: "20px !important",
        height: "auto",
        "&>path": {
          fill: "#5A6872  !important",
        },
      },
      "&:hover": {
        opacity: "0.7",
      },
    },
  },
  alignStatusMenu: {
    position: "relative",
    "&>div": {
      position: "absolute",
      top: "3px",
      left: "100px !important",
    },
  },
  rsStatusBox: {
    position: "relative",
    paddingTop: "5px",
  },
  rsStatusmenuList: {
    position: "absolute",
    top: "-10px",
    width: "200px",
    minWidth: "50px",
    left: "10px",
    height: "50px",
    zIndex: "9",
    opacity: "0",
  },
  rsSelectMenulist: {
    width: "80px",
    height: "40px",
  },
  rsPatientNameAlign: {
    marginRight: "0px",
    display: "flex",
    color: "#464646 !important",
    "&:hover": {
      color: "rgba(90, 104, 114, 0.8) !important",
      // cursor: "pointer",
    },
  },

  rsBtnMedication: {
    marginLeft: "32px !important",
    marginTop: "15px !important",
  },
  rsOrderGap: {
    marginLeft: "32px !important",
    position: "absolute",
    bottom: "45px",
  },
  rsOrderGapText: {
    "&>div": {
      marginLeft: "7px",
      display: "flex",
      alignItems: "center",
      "&>h4:nth-child(1)": {
        fontSize: "18px !important",
        color: "#262626 !important",
        fontWeight: "500",
        width: "max-content",
      },
      "&>h4:nth-child(2)": {
        fontSize: "11px !important",
        fontWeight: "500",
      },
    },
  },
  rsOrderDateDetails: {
    marginLeft: "32px !important",
  },
  chipMain: {
    position: "relative",
    marginLeft: "97px !important",
    height: "35px !important",
    minWidth: "170px !important",
    borderRadius: "5px !important",
    fontSize: "17px !important",
    cursor: "pointer  !important",
    border: `none !important`,
    marginTop: "15px !important",
  },
  rsMedDate: {
    marginLeft: "97px !important",
    height: "35px !important",
    minWidth: "170px !important",
    borderRadius: "5px !important",
    fontSize: "17px !important",
    cursor: "pointer  !important",
    border: `none !important`,
    marginTop: "-5px !important",
  },
  rsMenuAction: {
    display: "flex",
    height: "25px",
    position: "relative",
    alignItems: "center",
    listStyle: "none",
    "&>li": {
      padding: "0px !important",
    },
  },
  rseyeIcon: {
    // marginTop: "2px !important",
    "&>svg": {
      // marginTop: "-4px !important",
      width: "20px !important",
    },
  },
  rsnameCell: {
    display: "flex",
  },
  rsGreyInfo: {
    opacity: "0.6",
  },
  rsIconGreyInfo: {
    "&>div": {
      "&>path": {
        fill: "rgba(90, 104, 114, 0.6) !important",
      },
    },
    "&>svg": {
      "&>g": {
        "&>path": {
          fill: "rgba(90, 104, 114, 0.6) !important",
        },
      },
      "&>path": {
        fill: "rgba(90, 104, 114, 0.6) !important",
      },
    },
  },
  rsOrderCount: {
    // color: "RGB(123, 192, 68)",
    color: "green",
    fontSize: "12px",
    marginLeft: "5px",
    marginRight: "2px",
    cursor: "pointer",
  },
  rsCountTool: {
    left: "100px !important",
  },
  rsCrossIcon: {
    "&>svg": {
      fill: " rgb(233, 81, 78) !important",
    },
  },
  rsPrnform: {
    margin: "0px !important",
  },
  rsprnbtn: {
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
    minWidth: "15px !important",
    "&>span": {
      padding: "0px !important ",
    },
  },
  rstext: {
    "&>button": {
      minWidth: "15px !important",
      maxWidth: "20px !important",
      // paddingBottom: "5px !important",
    },
  },
  orderEdit: {
    color: "#5A6872",
    "&>span": {
      fontStyle: "italic",
    },
  },
  cardGroup: {
    background: "#AED581",
    borderRadius: "3px",
    margin: "0px",
    padding: "2px",
    color: "white",
    height: "20px",
    fontSize: "10px",
    padding: "4px 8px",
    fontWeight: "600 !important",
  },
  remainingTags: {
    color: "#2e5aff",
    cursor: "pointer",
    whiteSpace: "nowrap",
    fontWeight: "400",
    marginLeft: "3px",
  },
  groupColorIcon: {
    padding: "8px",
    margin: "3px",
    width: "10px",
    height: "10px",
    borderRadius: "3px !important",
  },
  addme: {
    marginTop: "-40px !important",
    marginLeft: "0px !important",
    height: "25px !important",
  },
  rsGreyInfoAddress: {
    display: "block",
    whiteSpace: "normal",
    width: "200px",
  },
  tooltip: {
    backgroundColor: "white !important",
    border: "0.5px solid #dadde9",
  },
  rsCloseIcon: {
    "&>svg": {
      "&>path": {
        fill: "red !important",
        stroke: "red !important",
      },
    },
    fill: "red !important",
  },
  chiphover: {
    "&:hover": {
      background: "#7BC044 !important",
      opacity: "1",
    },
  },
  errorMessage: {
    "&>div": {
      justifyContent: "center !important",
      display: "flex",
      alignContent: "center !important",
      "&>svg": {
        marginLeft: "4px !important",
      },
    },
  },
  ordergapMain: {
    "&>svg": {
      "&>path": {
        fill: "#E54C42",
      },
      "&>g": {
        "&>path": {
          // fill: "transparent",
          // stroke: "#E54C42",
          fill: "#E54C42",
        },
      },
    },
  },
  rsDateDetails: {
    display: "flex",
    flexDirection: "column !important",
    alignItems: "flex-start",
    marginBottom: "11px !important",
    marginTop: "11px !important",
    "&>h5": {
      width: "fit-content",
      fontWeight: "500",
    },
    "&>h4": {
      width: "fit-content",
      color: "#262626 !important",
      fontWeight: "500",
    },
  },
  WarningIconYellow: {
    "&>svg": {
      "&>g": {
        "&>path": {
          fill: "#fbc14d",
        },
      },
    },
  },
}));

const RepeatOrderTable = (props) => {
  const {
    i,
    item,
    setOpenEmailTemeplate,
    setOpenEmailTemplateId,
    setIsOrderRecordActionType,
    setIsOpenEditDateModel,
    setEditRepeatDate,
    setShowOrderNoteList,
    setShowPatientNoteList,
    setDeletePatient,
    setConfirmOpen,
    setOpenPatientNoteList,
    setPatientDeleteId,
    handleClickTickAction,
    isItemSelected,
    labelId,
    openCheckBoxColumn,
    setShowOrderMedicationDateDetails,
    showOrderMedicationDateDetails,
    setDetailsDialog,
    setPatientDetails,
    currentTableView,
    setOpenConfirmEdit,
    setOpenOrderNoteList,
    showOrderNoteList,
    tableCells,
    prnReview,
    setPrnReview,
    setPRNitem,
    setOrderPlace,
    setOrderItemList,
    orderId,
    setOrderId,
    isOrder,
    setisOrder,
    prnWarning,
    setPrnWarning,
    setPatientDetailOpen,
    setPatientId,
    cycleDialog,
    setCycleDialog,
    warningOrderdate,
    setWarningOrderdate,
    getSingleRepeatOrderAction,
    singleRepeatOrder,
    clickOrderPlace,
    setClickOrderPlace,
    openPatientStatus,
    setOpenPatientStatus,
    setPatientStatus,
  } = props;
  const classes = useStyle();
  const navigate = useNavigate();
  const { width } = useViewport();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { loginUserDetail } = useSelector((state) => state.user);

  const handlePopoverOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setShowOrderMedicationDateDetails(item);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  useEffect(() => {
    if (clickOrderPlace) {
      setClickOrderPlace(false);
      setOrderPlace(true);
    }
  }, [singleRepeatOrder]);

  const handleAutoSuggetion = (value) => {
    if (value) {
      const lowercasedValue = value.toLowerCase();
      const replacedValue = lowercasedValue.replace(/\s+/g, "-");
      const limitedValue = replacedValue.slice(0, 8);
      return limitedValue;
      // setFieldValue("g_tag", limitedValue);
    }
  };
  const lowercasedValue = item?.group?.g_name?.toLowerCase();
  const replacedValue = lowercasedValue?.replace(/\s+/g, "-");
  const limitedValue = replacedValue?.slice(0, 8);

  return (
    <>
      <TableRow key={item}>
        {openCheckBoxColumn && (
          <TableCell
            onClick={(event) => {
              handleClickTickAction(event, item, i);
            }}
          >
            <HtmlTooltipMain
              title={
                item?.order_type === "slow" && !item?.is_review_prn
                  ? "Medication Review Required"
                  : "" || item?.status === "Absent"
                    ? "Absent"
                    : "" || item?.status === "In-Hospital"
                      ? "In-Hospital"
                      : ""
              }
              placement="right"
            >
              <FormControlLabel
                className={classes.labelWhiteSpaceNW}
                checked={isItemSelected}
                control={<Checkbox color="primary" />}
                label=""
                inputProps={{
                  "aria-labelledby": labelId,
                }}
                disabled={item?.order_type == "slow" && !item?.is_review_prn}
              />
            </HtmlTooltipMain>
          </TableCell>
        )}
        <TableCell semiBold className="table-patient">
          <Box className={classes.iconContainer}>
            <Box className={classes.rsPatientInfo}>
              <Box
                className={clsx(
                  item?.status === "Absent" ||
                    item?.status === "In-Hospital" ||
                    item?.status === "Deceased"
                    ? classes.rsGreyInfo
                    : classes.rsPatientNameAlign,
                  "cursor-pointer",
                )}
                onClick={(event) => {
                  // setDetailsDialog(true);
                  // setPatientDetails(item);
                  setPatientId(item?.patient_id);
                  setPatientDetailOpen(true);
                }}
              >
                {item?.name}
                {` `}
                {item?.last_name}
              </Box>

              <Box
                className={clsx(
                  classes.rsAddress,
                  item?.status === "Absent" ||
                    item?.status === "In-Hospital" ||
                    item?.status === "Deceased"
                    ? classes.rsGreyInfo
                    : "",
                )}
              >
                {item?.dob
                  ? `(${
                      moment(new Date(item?.dob)).format("DD-MM-YYYY") ||
                      "N / A"
                    })`
                  : ""}
              </Box>
              {item.oos_count > 1 && (
                <Box className={classes.rsOrderCount}>
                  <HtmlTooltipMain
                    title="Multiple repeat orders exist for this patient."
                    className={classes.rsCountTool}
                  >
                    <Box>({item.oos_count})</Box>
                  </HtmlTooltipMain>
                </Box>
              )}
              {currentTableView === "basic" &&
                // item?.patient_type ||
                // item?.compliance_aid ||
                (item?.group?.g_tag ||
                  item?.group?.g_name ||
                  item?.tags?.length > 0) && (
                  // item?.instalment_type
                  // ||
                  // item?.status !== "Active"
                  <Box
                    className={clsx(
                      classes.rsVisibilityIcon,
                      item?.status === "Absent" ||
                        item?.status === "In-Hospital" ||
                        item?.status === "Deceased"
                        ? classes.rsGreyInfo
                        : "",
                    )}
                  >
                    <HtmlTooltipMain
                      placement="bottom-start"
                      className={classes.rsHtmlToolTipchip}
                      title={
                        <Grid container className={classes.rsChipsStatusTool}>
                          {/* {item?.status !== "Active" && (
                            <Chips
                              // key={i}
                              label={item?.status}
                              color={
                                item?.status === "Absent"
                                  ? "rgba(107, 107, 107,0.6)"
                                  : item?.status === "In-Hospital"
                                  ? "rgba(210, 162, 68,0.6)"
                                  : item?.status === "Deceased"
                                  ? "rgba(255, 0, 0,0.6)"
                                  : "rgba(28, 176, 68,0.6)"
                              }
                              onClick={(e, index) => {
                                setPatientId(item?.patient_id);
                                setOpenPatientStatus(true);
                                if (item?.status === "Absent") {
                                  setPatientStatus("absent");
                                } else if (item?.status === "In-Hospital") {
                                  setPatientStatus("in_hospital");
                                } else if (item?.status === "Deceased") {
                                  setPatientStatus("deceased");
                                } else {
                                  setPatientStatus("active");
                                }
                                // setPatientStatus(item?.status);
                                // handleStatusOpen(i);
                              }}
                            />
                          )} */}
                          {item?.group?.g_tag ? (
                            <Box
                              item
                              display="flex"
                              className={classes.cardGroup}
                              style={{
                                background: item?.group?.g_color_code,
                                marginLeft: "3px",
                              }}
                            >
                              {/* <Card
                                className={classes.groupColorIcon}
                                style={{
                                  background: item?.group?.g_color_code,
                                }}
                              /> */}
                              {` ${item?.group?.g_tag}`}
                            </Box>
                          ) : item?.group?.g_name ? (
                            <Box
                              item
                              display="flex"
                              className={classes.cardGroup}
                              style={{
                                background: item?.group?.g_color_code,
                              }}
                            >
                              {/* <Card
                              className={classes.groupColorIcon}
                              style={{
                                background: item?.group?.g_color_code,
                              }}
                            /> */}
                              {` ${limitedValue}`}
                            </Box>
                          ) : (
                            ""
                          )}
                          {/* <Box
                            item
                            display="flex"
                            //gridTemplateColumns="repeat(5, 1fr)"
                          > */}
                          {item?.tags.map((tagvalue) => {
                            return (
                              <Chips
                                className={classes.cursorMain}
                                rippleEffectEnabled={true}
                                click
                                label={tagvalue?.pit_name}
                                color={tagvalue?.pit_colour_code}
                              />
                            );
                          })}

                          {/* {item?.patient_type === "collection" && (
                            <Chips
                              label="Collection"
                              color={
                                item?.status === "Absent" ||
                                item?.status === "In-Hospital" ||
                                item?.status === "Deceased"
                                  ? "rgba(107, 107, 107,0.6)"
                                  : "#429600"
                              }
                            />
                          )}
                          {item?.patient_type === "delivery" && (
                            <Chips
                              label="Delivery"
                              color={
                                item?.status === "Absent" ||
                                item?.status === "In-Hospital" ||
                                item?.status === "Deceased"
                                  ? "rgba(107, 107, 107,0.6)"
                                  : "rgba(218, 120, 32, 0.6)"
                              }
                            />
                          )}
                          {item?.compliance_aid && (
                            <Chips
                              label="Compliance"
                              color={
                                item?.status === "Absent" ||
                                item?.status === "In-Hospital" ||
                                item?.status === "Deceased"
                                  ? "rgba(107, 107, 107,0.6)"
                                  : "rgba(137, 156, 18, 0.6)"
                              }
                            />
                          )}
                          {item?.instalment_type && (
                            <Chips
                              label={
                                InstallmentDispensingDetail[
                                  item?.instalment_type
                                ].label
                              }
                              color={
                                item?.status === "Absent" ||
                                item?.status === "In-Hospital" ||
                                item?.status === "Deceased"
                                  ? "rgba(107, 107, 107,0.6)"
                                  : "rgba(56, 91, 177, 0.6)"
                              }
                            />
                          )} */}

                          {/* {item?.order_type === "slow" ? (
                            <HtmlTooltipMain title="Medication Review Required">
                              <Box
                                className={
                                  item?.status === "Absent" ||
                                  item?.status === "In-Hospital"
                                    ? classes.rsIconGreyInfo
                                    : ""
                                }
                              >
                                <PrimaryIcon
                                  color="primary"
                                  width="20px"
                                  height="30px"
                                  icon={MedicationRequiredIcon}
                                  cursor="pointer"
                                  style={{ marginLeft: "10px" }}
                                />
                              </Box>
                            </HtmlTooltipMain>
                          ) : (
                            <HtmlTooltipMain title="Quick Order">
                              <Box
                                className={
                                  item?.status === "Absent" ||
                                  item?.status === "In-Hospital"
                                    ? classes.rsIconGreyInfo
                                    : ""
                                }
                              >
                                <PrimaryIcon
                                  color="primary"
                                  width="30px"
                                  height="30px"
                                  icon={QuickIcon}
                                  cursor="pointer"
                                  style={{ marginLeft: "10px" }}
                                />
                              </Box>
                            </HtmlTooltipMain>
                          )} */}
                        </Grid>
                      }
                    >
                      <Box classes={classes.rseyeIcon}>
                        <PrimaryIcon
                          color="secondary"
                          width="12px"
                          icon={VisibilityOutlinedIcon}
                          cursor="pointer"
                        />
                      </Box>
                    </HtmlTooltipMain>
                  </Box>
                )}
            </Box>
          </Box>
          {currentTableView === "basic" && item?.status !== "Active" && (
            <Chips
              className={classes.chiphover}
              // key={i}
              label={item?.status}
              color={
                item?.status === "Absent"
                  ? "rgba(107, 107, 107,0.6)"
                  : item?.status === "In-Hospital"
                    ? "rgba(210, 162, 68,0.6)"
                    : item?.status === "Deceased"
                      ? "rgba(107,107,107,0.6)"
                      : // "rgba(255, 0, 0,0.6)"
                        "rgba(28, 176, 68,0.6)"
              }
              onClick={(e, index) => {
                setPatientId(item?.patient_id);
                setOpenPatientStatus(true);
                if (item?.status === "Absent") {
                  setPatientStatus("absent");
                } else if (item?.status === "In-Hospital") {
                  setPatientStatus("in_hospital");
                } else if (item?.status === "Deceased") {
                  setPatientStatus("deceased");
                } else {
                  setPatientStatus("active");
                }
                // setPatientStatus(item?.status);
                // handleStatusOpen(i);
              }}
            />
          )}
          {currentTableView === "advance" && (
            <>
              {
                // item?.patient_type ||
                // item?.compliance_aid ||
                (item?.group?.g_tag ||
                  item?.group?.g_name ||
                  // item?.instalment_type ||
                  item?.tags?.length > 0 ||
                  item?.status !== "Active") && (
                  <Box className={classes.rsChipsStatus}>
                    {item?.status !== "Active" && (
                      <Chips
                        // key={i}
                        label={item?.status}
                        color={
                          item?.status === "Absent"
                            ? "rgba(107, 107, 107,0.6)"
                            : item?.status === "In-Hospital"
                              ? "rgba(210, 162, 68,0.6)"
                              : item?.status === "Deceased"
                                ? "rgba(107,107,107,0.6"
                                : //  "rgba(255, 0, 0,0.6)"
                                  "rgba(28, 176, 68,0.6)"
                        }
                        onClick={(e, index) => {
                          setPatientId(item?.patient_id);
                          setOpenPatientStatus(true);
                          if (item?.status === "Absent") {
                            setPatientStatus("absent");
                          } else if (item?.status === "In-Hospital") {
                            setPatientStatus("in_hospital");
                          } else if (item?.status === "Deceased") {
                            setPatientStatus("deceased");
                          } else {
                            setPatientStatus("active");
                          }

                          // handleStatusOpen(i);
                        }}
                      />
                    )}
                    {item?.group?.g_tag ? (
                      <Box
                        display="flex"
                        className={classes.cardGroup}
                        style={{
                          background: item?.group?.g_color_code,
                        }}
                      >
                        {/* <Card
                        className={classes.groupColorIcon}
                        style={{
                          background: item?.group?.g_color_code,
                        }}
                      /> */}
                        {` ${item?.group?.g_tag}`}
                      </Box>
                    ) : item?.group?.g_name ? (
                      <Box
                        display="flex"
                        className={classes.cardGroup}
                        style={{
                          background: item?.group?.g_color_code,
                        }}
                      >
                        {/* <Card
                  className={classes.groupColorIcon}
                  style={{
                    background: item?.group?.g_color_code,
                  }}
                /> */}
                        {` ${limitedValue}`}
                      </Box>
                    ) : (
                      ""
                    )}
                    {item?.tags
                      ?.slice(
                        0,
                        !!(item?.status !== "Active" && item?.g_tag)
                          ? 1
                          : !!(item?.status !== "Active" || item?.g_tag)
                            ? 2
                            : 2,
                      )
                      .map((tagvalue, index) => (
                        <Chips
                          key={index}
                          className={classes.cursorMain}
                          rippleEffectEnabled={true}
                          click
                          label={tagvalue?.pit_name}
                          color={
                            item?.status === "Absent" ||
                            item?.status === "Deceased"
                              ? "rgba(107, 107, 107, 0.6)"
                              : tagvalue?.pit_colour_code
                          }
                        />
                      ))}
                    {item?.tags?.length >
                      (!!(item?.status !== "Active" && item?.g_tag)
                        ? 1
                        : 2) && (
                      <Tooltip
                        // open={true}
                        classes={{ tooltip: classes.tooltip }}
                        title={
                          <Box>
                            {item?.tags
                              ?.slice(
                                !!(item?.status !== "Active" && item?.g_tag)
                                  ? 1
                                  : 2,
                              )
                              .map((tagvalue, index) => (
                                <Chips
                                  className={classes.cursorMain}
                                  rippleEffectEnabled={true}
                                  click
                                  label={tagvalue?.pit_name}
                                  color={tagvalue?.pit_colour_code}
                                />
                              ))}
                          </Box>
                        }
                      >
                        <Box className={classes.remainingTags}>
                          {`+${
                            item?.tags?.length -
                            (!!(item?.status !== "Active" && item?.g_tag)
                              ? 1
                              : 2)
                          }`}
                        </Box>
                      </Tooltip>
                    )}

                    {/* {item?.patient_type === "collection" && (
                    <Chips
                      label="Collection"
                      color={
                        item?.status === "Absent" ||
                        item?.status === "Deceased" ||
                        item?.status === "In-Hospital"
                          ? "rgba(107, 107, 107,0.6)"
                          : "#429600"
                      }
                    />
                  )}
                  {item?.patient_type === "delivery" && (
                    <Chips
                      label="Delivery"
                      color={
                        item?.status === "Absent" ||
                        item?.status === "In-Hospital" ||
                        item?.status === "Deceased"
                          ? "rgba(107, 107, 107,0.6)"
                          : "rgba(218, 120, 32, 0.6)"
                      }
                    />
                  )}
                  {item?.compliance_aid && (
                    <Chips
                      label="Compliance"
                      color={
                        item?.status === "Absent" ||
                        item?.status === "In-Hospital" ||
                        item?.status === "Deceased"
                          ? "rgba(107, 107, 107,0.6)"
                          : "rgba(137, 156, 18, 0.6)"
                      }
                    />
                  )}
                  {item?.instalment_type && (
                    <Chips
                      label={
                        InstallmentDispensingDetail[item?.instalment_type].label
                      }
                      color={
                        item?.status === "Absent" ||
                        item?.status === "In-Hospital" ||
                        item?.status === "Deceased"
                          ? "rgba(107, 107, 107,0.6)"
                          : "rgba(56, 91, 177, 0.6)"
                      }
                    />
                  )} */}
                    {/* {item?.order_type === "slow" ? (
                    <HtmlTooltipMain title="Medication Review Required">
                      <Box
                        className={
                          item?.status === "Absent" ||
                          item?.status === "In-Hospital"
                            ? classes.rsIconGreyInfo
                            : ""
                        }
                      >
                        <PrimaryIcon
                          color="primary"
                          width="20px"
                          height="30px"
                          icon={MedicationRequiredIcon}
                          cursor="pointer"
                          style={{ marginLeft: "10px" }}
                        />
                      </Box>
                    </HtmlTooltipMain>
                  ) : (
                    <HtmlTooltipMain title="Quick Order">
                      <Box
                        className={
                          item?.status === "Absent" ||
                          item?.status === "In-Hospital"
                            ? classes.rsIconGreyInfo
                            : ""
                        }
                      >
                        <PrimaryIcon
                          color="primary"
                          width="30px"
                          height="30px"
                          icon={QuickIcon}
                          cursor="pointer"
                          style={{ marginLeft: "10px" }}
                        />
                      </Box>
                    </HtmlTooltipMain>
                  )} */}
                  </Box>
                )
              }
            </>
          )}
        </TableCell>
        {/* <TableCell>{item?.n_name || "-"}</TableCell> */}
        {Object.keys(tableCells).map((columnName) => {
          return (
            <>
              {tableCells[columnName].show && (
                <>
                  {columnName === "Nurse_Name" && (
                    <TableCell>{item?.n_name || "-"}</TableCell>
                  )}
                  {columnName === "order_date" && (
                    <TableCell
                      className={clsx(
                        classes.rsOrderDate,
                        item?.status === "Absent" ||
                          item?.status === "In-Hospital" ||
                          item?.status === "Deceased"
                          ? classes.rsGreyInfo
                          : "",
                      )}
                    >
                      {/* <Box> */}
                      <span
                        onMouseEnter={(e) => {
                          if (item?.order_date) {
                            handlePopoverOpen(e, item);
                          }
                        }}
                        style={{ cursor: "initial" }}
                        onMouseLeave={handlePopoverClose}
                      >
                        {!item?.order_date &&
                        item?.status !== "Absent" &&
                        item?.status !== "In-Hospital" ? (
                          <Box className="addme_effect_order_date">
                            <Chips
                              className={classes.addme}
                              color={"rgba(123, 192,  68,1)"}
                              variant={"filled"}
                              textColor={"rgba(255,255,255,1)"}
                              borderColorChip={"rgba(123, 192,  68,1)"}
                              label="Add me"
                              width="58px"
                              onClick={() => {
                                setIsOrderRecordActionType("editOrderDate");
                                setIsOpenEditDateModel(true);
                                setEditRepeatDate(item);
                              }}
                            />
                          </Box>
                        ) : item?.order_date ? (
                          moment(new Date(item?.order_date)).format(
                            "Do MMM (ddd)",
                          ) || "N / A"
                        ) : (
                          "-"
                        )}
                        {` `}
                      </span>
                      {item?.status === "Absent" ||
                        item?.order_date === null ||
                        item?.status === "In-Hospital" || (
                          <IconButton className={classes.rseditDateIcon}>
                            <PrimaryIcon
                              color="white"
                              width="20px"
                              icon={EditIcon}
                              cursor="pointer"
                              onClick={() => {
                                setIsOrderRecordActionType("editOrderDate");
                                setEditRepeatDate(item);
                                setIsOpenEditDateModel(true);
                              }}
                            />
                          </IconButton>
                        )}
                      {/* </Box> */}

                      <Box className={classes.orderEdit}>
                        {item?.order_logs?.length > 0 ? (
                          <HtmlTooltipOrderdate
                            interactive={true}
                            title={
                              <React.Fragment>
                                <ul>
                                  <tr>
                                    <td
                                      style={{
                                        minWidth: "74px",
                                        width: "50px",
                                        whiteSpace: "nowrap",
                                        border: "1px",
                                        borderColor: "white",
                                        borderStyle: "solid",
                                        padding: "5px",
                                      }}
                                    >
                                      OLD ORDER DATE
                                    </td>
                                    <td
                                      style={{
                                        minWidth: "74px",
                                        width: "50px",
                                        whiteSpace: "nowrap",
                                        border: "1px",
                                        borderColor: "white",
                                        borderStyle: "solid",
                                        padding: "5px",
                                      }}
                                    >
                                      NEW ORDER DATE
                                    </td>
                                    <td
                                      style={{
                                        minWidth: "74px",
                                        width: "50px",
                                        border: "1px",
                                        borderColor: "white",
                                        borderStyle: "solid",
                                        padding: "5px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      EDITED BY
                                    </td>
                                  </tr>
                                </ul>
                                <ul>
                                  {item?.order_logs?.map((item) => {
                                    return (
                                      <>
                                        <tr>
                                          <td
                                            style={{
                                              minWidth: "111px",
                                              width: "52px",
                                              whiteSpace: "nowrap",
                                              border: "1px",
                                              borderColor: "white",
                                              borderStyle: "solid",
                                              padding: "5px",
                                              // borderRight: "none !important",
                                              // borderTop: "none !important",
                                            }}
                                          >
                                            {moment(
                                              new Date(item?.ol_old_order_date),
                                            ).format("DD-MM-YYYY")}
                                          </td>
                                          <td
                                            style={{
                                              minWidth: "114px",
                                              width: "50px",
                                              whiteSpace: "nowrap",
                                              border: "1px",
                                              borderColor: "white",
                                              borderStyle: "solid",
                                              padding: "5px",
                                              // borderRight: "none",
                                              // borderLeft: "none",
                                            }}
                                          >
                                            {moment(
                                              new Date(item?.ol_new_order_date),
                                            ).format("DD-MM-YYYY")}
                                          </td>
                                          <td
                                            style={{
                                              minWidth: "74px",
                                              width: "50px",
                                              border: "1px",
                                              borderColor: "white",
                                              borderStyle: "solid",
                                              padding: "5px",
                                            }}
                                          >
                                            {item?.name}
                                          </td>
                                        </tr>
                                      </>

                                      // <li>{item?.drug_name}</li>
                                    );
                                  })}
                                </ul>
                              </React.Fragment>
                            }
                          >
                            {`+${item?.order_logs?.length} edited`}
                          </HtmlTooltipOrderdate>
                        ) : (
                          ""
                        )}
                      </Box>

                      {/* {item?.driver?.length > 0 ? (
                                                <HtmlTooltipMain
                                                  interactive={true}
                                                  title={
                                                    <Grid>
                                                      {item?.driver
                                                        ?.slice(1)
                                                        .map(
                                                          (option, index) => (
                                                            <Box>
                                                              {option.name}
                                                            </Box>
                                                          )
                                                        )}
                                                    </Grid>
                                                  }
                                                >
                                                  <div
                                                    className={classes.itemWrap}
                                                  >
                                                    {item?.driver?.length - 1 >
                                                    0
                                                      ? ` +
                                                          ${
                                                            item?.driver
                                                              ?.length -
                                                            Math.min(
                                                              1,
                                                              item?.driver
                                                                ?.length
                                                            )
                                                          }
                                                          more`
                                                      : ""}
                                                  </div>
                                                </HtmlTooltipMain>
                                              ) : (
                                                "-"
                                              )} */}
                    </TableCell>
                  )}
                  {columnName === "medication_date" && (
                    <TableCell
                      className={clsx(
                        classes.rsMediDate,
                        item?.status === "Absent" ||
                          item?.status === "In-Hospital" ||
                          item?.status === "Deceased"
                          ? classes.rsGreyInfo
                          : "",
                      )}
                    >
                      <Box display={"flex"} cursor={"pointer"}>
                        {item?.medication_date === null
                          ? "-"
                          : moment(new Date(item?.medication_date)).format(
                              "Do MMM (ddd)",
                            ) || "N / A"}
                        {(item?.order_gap_status === 1 ||
                          item?.order_gap_status === 3) && (
                          // <HtmlTooltipMain title="Order date must be prior to medication date">
                          <span
                            onMouseEnter={(e) => {
                              // if (item?.order_gap_status) {
                              handlePopoverOpen(e, item);
                              // }
                            }}
                            style={{ cursor: "initial" }}
                            onMouseLeave={handlePopoverClose}
                          >
                            <Box className={classes.ordergapMain}>
                              <PrimaryIcon
                                icon={
                                  // item?.order_gap > 0 ? AlertIcon : Refresh
                                  item?.order_gap_status === 1
                                    ? AlertIcon
                                    : item?.order_gap_status === 3 ||
                                        item?.order_gap_status === 0
                                      ? Refresh
                                      : AlertIcon
                                  // item?.order_gap > 0 ? ErrorIcon : syncIconMain
                                }
                                marginLeft="2px"
                                marginTop="5px"
                                width="18px"
                                height={"18px"}
                              />
                            </Box>

                            {/* </HtmlTooltipMain> */}
                          </span>
                          // <ErrorIcon width="20px" height={"20px"} />
                        )}
                        {item?.order_gap_status === 2 && (
                          // <HtmlTooltipMain title="Order date must be prior to medication date">
                          <span
                            onMouseEnter={(e) => {
                              // if (item?.order_gap_status) {
                              handlePopoverOpen(e, item);
                              // }
                            }}
                            style={{ cursor: "initial" }}
                            onMouseLeave={handlePopoverClose}
                          >
                            <Box className={classes.WarningIconYellow}>
                              <PrimaryIcon
                                icon={AlertIcon}
                                marginLeft="2px"
                                marginTop="5px"
                                width="18px"
                                height={"18px"}
                              />
                            </Box>
                            {/* // </HtmlTooltipMain> */}
                            {/* // <ErrorIcon width="20px" height={"20px"} /> */}
                          </span>
                        )}

                        {item?.status === "Absent" ||
                          item?.order_date === null ||
                          item?.status === "In-Hospital" || (
                            <IconButton className={classes.rseditDateIcon}>
                              <PrimaryIcon
                                color="white"
                                width="20px"
                                icon={EditIcon}
                                cursor="pointer"
                                onClick={() => {
                                  setIsOrderRecordActionType("editOrderDate");
                                  setEditRepeatDate(item);
                                  setIsOpenEditDateModel(true);
                                }}
                              />
                            </IconButton>
                          )}
                      </Box>
                    </TableCell>
                  )}
                  {columnName === "address" && (
                    <TableCell>
                      <HtmlTooltipMain title={item?.address}>
                        <Box
                          className={
                            item?.status === "Absent" ||
                            item?.status === "In-Hospital" ||
                            item?.status === "Deceased"
                              ? classes.rsGreyInfo
                              : classes.rsGreyInfoAddress
                          }
                        >
                          {item?.address
                            ? // ? getEllipsisName(item?.address, 30)
                              item?.address
                            : "-"}
                        </Box>
                      </HtmlTooltipMain>
                    </TableCell>
                  )}
                  {columnName === "patien_medications_count" && (
                    <TableCell
                      className={clsx(
                        classes.rsCursorPointer,
                        item?.status === "Absent" ||
                          item?.status === "In-Hospital" ||
                          item?.status === "Deceased"
                          ? classes.rsGreyInfo
                          : "",
                      )}
                    >
                      <HtmlTooltipMain
                        title={
                          <React.Fragment>
                            <ul>
                              {item.patient_medications?.length !== 0
                                ? item?.patient_medications?.map((item) => {
                                    return <li>{item?.drug_name}</li>;
                                  })
                                : `Total medication: ${item?.number_of_medication}`}
                            </ul>
                          </React.Fragment>
                        }
                      >
                        <Grid>
                          {item?.number_of_medication
                            ? item?.number_of_medication
                            : item?.patien_medications_count || "-"}
                        </Grid>
                      </HtmlTooltipMain>
                    </TableCell>
                  )}
                  {columnName === "surgery_name" && (
                    <TableCell>
                      <HtmlTooltipMain
                        className={classes.rsHtmlToolTip}
                        title={item?.surgery_name}
                      >
                        <Box
                          className={clsx(
                            classes.rsEllipisisInfo,
                            item?.status === "Absent" ||
                              item?.status === "In-Hospital" ||
                              item?.status === "Deceased"
                              ? classes.rsGreyInfo
                              : "",
                          )}
                        >
                          <span className={classes.textInfo}>
                            {width > 1600
                              ? getEllipsisName(item?.surgery_name, 30)
                              : getEllipsisName(item?.surgery_name, 18)}
                          </span>
                        </Box>
                      </HtmlTooltipMain>
                    </TableCell>
                  )}
                  {columnName === "previous_order_date" && (
                    <TableCell
                      className={
                        item?.status === "Absent" ||
                        item?.status === "In-Hospital" ||
                        item?.status === "Deceased"
                          ? classes.rsGreyInfo
                          : ""
                      }
                    >
                      <Box>
                        <HtmlTooltipMain
                          className={classes.rsHtmlToolTip}
                          title={
                            item?.previous_order_date === null
                              ? ""
                              : moment(
                                  new Date(item?.previous_order_date),
                                ).format("Do MMMM YYYY") || "N / A"
                          }
                        >
                          <Box className={classes.rsEllipisisInfo}>
                            {item?.previous_order_date === null
                              ? "-"
                              : moment(
                                  new Date(item?.previous_order_date),
                                ).format("Do MMM") || "N / A"}
                          </Box>
                        </HtmlTooltipMain>
                      </Box>
                    </TableCell>
                  )}
                  {columnName === "weeks" && (
                    <TableCell
                      className={
                        item?.status === "Absent" ||
                        item?.status === "In-Hospital" ||
                        item?.status === "Deceased"
                          ? classes.rsGreyInfo
                          : ""
                      }
                    >
                      <Box style={{ marginBottom: "9px" }}>
                        {item?.weeks || "-"}
                      </Box>
                    </TableCell>
                  )}

                  {columnName === "warning" && (
                    <TableCell>
                      {item?.order_gap_status === 1 && (
                        <span
                          onMouseEnter={(e) => {
                            // if (item?.order_gap_status) {
                            handlePopoverOpen(e, item);
                            // }
                          }}
                          style={{ cursor: "initial" }}
                          onMouseLeave={handlePopoverClose}
                        >
                          <IconButton
                            className={clsx(
                              classes.rsIconBtn,
                              item?.status === "Absent" ||
                                item?.status === "In-Hospital" ||
                                item?.status === "Deceased"
                                ? classes.rsIconGreyInfo
                                : "",
                            )}
                          >
                            {" "}
                            <ErrorIcon width="20px" height={"20px"} />{" "}
                          </IconButton>
                        </span>
                      )}
                      {item?.order_gap_status === 2 && (
                        <span
                          onMouseEnter={(e) => {
                            // if (item?.order_gap_status) {
                            handlePopoverOpen(e, item);
                            // }
                          }}
                          style={{ cursor: "initial" }}
                          onMouseLeave={handlePopoverClose}
                        >
                          <IconButton
                            className={clsx(
                              classes.rsIconBtn,
                              item?.status === "Absent" ||
                                item?.status === "In-Hospital" ||
                                item?.status === "Deceased"
                                ? classes.rsIconGreyInfo
                                : "",
                            )}
                          >
                            {" "}
                            <WarningIcon width="20px" height={"20px"} />
                          </IconButton>
                        </span>
                      )}
                    </TableCell>
                  )}

                  {columnName === "pharmacy_name" && (
                    <TableCell
                      className={
                        item?.status === "Absent" ||
                        item?.status === "In-Hospital" ||
                        item?.status === "Deceased"
                          ? classes.rsGreyInfo
                          : ""
                      }
                    >
                      {item?.pharmacy_name || "-"}
                    </TableCell>
                  )}
                </>
              )}
            </>
          );
        })}
        <TableCell height={"60px"}>
          {item?.order_type === "quick" && (
            <>
              <Box className={classes.rstext}>
                <HtmlTooltipMain title="Not required">
                  <Button className={classes.rsprnbtn} onClick={() => {}}>
                    <CloseIcon className="order_Close_Icon" />
                    {/* <Checkbox
                      icon={<DisabledByDefaultIcon />}
                      checkedIcon={<DisabledByDefaultIcon />}
                      className={classes.rsCrossIcon}
                    /> */}
                  </Button>
                </HtmlTooltipMain>
              </Box>
            </>
          )}
          {/* {item?.order_type === "quick" && (
            <Box className={classes.rstext}>
              <HtmlTooltipMain title="Not required">
                <Button
                  className={classes.rsprnbtn}
                  onClick={() => {
                    // if (item?.weeks == null) {
                    //   setCycleDialog(true);
                    //   setPRNitem(item);
                    // } else {
                    // }
                  }}
                >
                  <CloseIcon className="order_Close_Icon" />
                </Button>
              </HtmlTooltipMain>
            </Box>
          )} */}
          {/* {item?.medication_type === "specific" && ( */}
          <>
            {item?.order_type !== "quick" && item?.is_review_prn === true && (
              <Box className={classes.rstext}>
                <HtmlTooltipMain title="completed">
                  <Button
                    className={classes.rsprnbtn}
                    onClick={() => {
                      // if (item?.weeks == null) {
                      //   setCycleDialog(true);
                      //   setPRNitem(item);
                      // }
                    }}
                    // setCycleDialog
                  >
                    <TaskAltIcon className="order_tick_icon" />
                    {/* <Checkbox
                        color="primary"
                        checked={item?.is_review_prn === true}
                      /> */}
                  </Button>
                </HtmlTooltipMain>
              </Box>
            )}
          </>
          {/* )} */}
          {/* {item?.medication_type === "specific" && ( */}
          <>
            {item?.order_type !== "quick" && item?.is_review_prn === false && (
              <Box className={classes.rstext}>
                <HtmlTooltipMain title="To be completed">
                  <Button
                    className={classes.rsprnbtn}
                    onClick={() => {
                      // if (item?.weeks == null) {
                      //   setCycleDialog(true);
                      //   setPRNitem(item);
                      // } else {
                      setPrnReview(true);
                      setOrderId(item?.id);
                      // setPrnReview(true);
                      setPRNitem(item);
                      setPrnWarning(false);
                      // }
                    }}
                  >
                    <Checkbox
                      color="primary"
                      checked={item?.is_review_prn === true}
                    />
                  </Button>
                </HtmlTooltipMain>
              </Box>
            )}
          </>
          {/* )} */}
          {/* {item?.medication_type === "specific" && ( */}
          {/* <>
            {" "}
            {item?.order_type === "quick" && (
              <Box className={classes.rstext}>
                <HtmlTooltipMain title="Not required">
                  <Button
                    className={classes.rsprnbtn}
                    onClick={() => {
                      // if (item?.weeks == null) {
                      //   setCycleDialog(true);
                      //   setPRNitem(item);
                      // } else {
                      // }
                    }}
                  >
                    <CloseIcon className="order_Close_Icon" />
                  </Button>
                </HtmlTooltipMain>
              </Box>
            )}
          </> */}
          {/* )} */}
        </TableCell>
        <TableCell className="table-action">
          <Box display={"flex"} fontWeight="300" alignItems={"center"}>
            {/* {console.log("item", item)} */}

            <HtmlTooltipMain title="Order">
              <IconButton
                className={clsx(
                  item?.is_today_order ? "pulse-icon" : "",
                  item?.is_today_order ? "order_icon_effect" : "",
                  item?.status === "Absent" ||
                    item?.status === "In-Hospital" ||
                    item?.status === "Deceased"
                    ? classes.rsDisabledicon
                    : item?.is_today_order
                      ? classes.hoverAlignBtnTodays
                      : classes.hoverAlignBtn,
                )}
                disabled={
                  item?.status === "Absent" || item?.status === "In-Hospital"
                    ? true
                    : false
                }
                onClick={() => {
                  // if (item?.weeks == null) {
                  //   setCycleDialog(true);
                  //   setPRNitem(item);
                  // } else {
                  if (item?.order_date == null) {
                    setWarningOrderdate(true);
                  } else {
                    setPrnWarning(true);
                    setLocalStorage("order_type", item?.order_type);
                    setLocalStorage("medi_type", item?.medication_type);
                    if (item?.medication_type === "specific") {
                      if (
                        item?.order_type !== "quick" &&
                        item?.is_review_prn !== true
                      ) {
                        setPrnReview(true);
                        // setPrnReview(true);
                        setPRNitem(item);

                        setOrderId(item?.id);
                        setisOrder(true);
                      } else {
                        setClickOrderPlace(true);
                        // setOrderPlace(true);
                        getSingleRepeatOrderAction(item?.id);
                      }
                      setOrderItemList(item);
                      setOrderId(item?.id);
                    } else {
                      setClickOrderPlace(true);
                      // setOrderPlace(true);
                      getSingleRepeatOrderAction(item?.id);
                      setOrderItemList(item);
                      setOrderId(item?.id);
                    }
                  }

                  // }

                  // if (item?.order_notes) {
                  //   setOpenOrderNoteList(true);
                  //   setIsOrderRecordActionType("orderNote");
                  //   setShowOrderNoteList(item);
                  // } else {
                  // navigate(
                  //   `/order?orderMethod=order-pad&actionType=repeatOrderPage&orderId=${item?.id}&patient_id=${item?.patient_id}`
                  // );
                  // }
                }}
              >
                <PrimaryIcon
                  width="20px"
                  icon={OrderShipIcon}
                  cursor="pointer"
                />
              </IconButton>
            </HtmlTooltipMain>

            <HtmlTooltipMain
              title="View Notes"
              onClick={() => {
                setIsOrderRecordActionType("viewNotes");
                setShowPatientNoteList(item);
                setOpenPatientNoteList(true);
              }}
            >
              {item?.note_count > 0 ? (
                <IconButton className="hoverAlign">
                  <Badge
                    color="red"
                    variant="dot"
                    sx={{
                      "& .MuiBadge-badge": {
                        zIndex: "auto",
                        background: "red",
                      },
                    }}
                  >
                    <PrimaryIcon
                      width="20px"
                      icon={NoteIcon}
                      cursor="pointer"
                    />
                  </Badge>
                </IconButton>
              ) : (
                <IconButton className="hoverAlign">
                  <PrimaryIcon width="20px" icon={NoteIcon} cursor="pointer" />
                </IconButton>
              )}
            </HtmlTooltipMain>

            <HtmlTooltipMain title="Edit Order">
              <IconButton className="hoverAlign">
                <PrimaryIcon
                  color="primary"
                  width="20px"
                  icon={EditIcon}
                  cursor="pointer"
                  onClick={() => {
                    navigate(`/order?actionType=edit&orderId=${item?.id}`);
                  }}
                />
              </IconButton>
            </HtmlTooltipMain>
            <HtmlTooltipMain title="Delete Order">
              <IconButton
                className="hoverAlign"
                onClick={() => {
                  setDeletePatient(true);
                  setPatientDeleteId(item?.id);
                }}
              >
                <PrimaryIcon width="20px" icon={DeleteIcon} cursor="pointer" />
              </IconButton>
            </HtmlTooltipMain>
          </Box>
        </TableCell>
      </TableRow>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        PaperProps={{
          className: classes.popoverPaper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Grid
          container
          display={"flex"}
          flexDirection={"row"}
          alignItems={"flex-end"}
          sx={{
            backgroundColor:
              showOrderMedicationDateDetails?.order_gap_status === 2
                ? "#FFFFE0"
                : showOrderMedicationDateDetails?.order_gap_status === 1 ||
                    showOrderMedicationDateDetails?.order_gap_status === 3
                  ? "#FFDDDC"
                  : "white",
            color: "white",
            boxShadow:
              "0px 8px 15px rgba(110, 117, 130, 0.15), 0px 1px 2px rgba(110, 117, 130, 0.3)",
          }}
        >
          <Grid
            item
            className={classes.rsDateDetails}
            marginLeft={"20px"}
            marginRight={"10px"}
          >
            <Typography color="secondary" regular variant="h5">
              Order Date
            </Typography>
            <Typography color="secondary" regular variant="h4">
              {showOrderMedicationDateDetails?.order_date === null
                ? "-"
                : moment(
                    new Date(showOrderMedicationDateDetails?.order_date),
                  ).format("DD/MM/YYYY") || "N / A"}
            </Typography>
          </Grid>

          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            lg={4}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            marginBottom={"20px"}
            marginTop={"11px"}
          >
            <Grid
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid display={"flex"} alignItems={"center"}>
                <Grid xs={2} sm={2} md={2} lg={2} marginRight={"10px"}>
                  {(showOrderMedicationDateDetails?.order_gap_status === 1 ||
                    showOrderMedicationDateDetails?.order_gap_status === 3) && (
                    <Grid xs={12} sm={12} md={12} lg={12} display={"flex"}>
                      <Box display={"flex"} className={classes.ordergapMain}>
                        <PrimaryIcon
                          width="25px"
                          height="25px"
                          icon={item?.order_gap > 0 ? AlertIcon : Refresh}
                        />
                      </Box>
                    </Grid>
                  )}
                  {showOrderMedicationDateDetails?.order_gap_status === 2 && (
                    <Grid xs={12} sm={12} md={12} lg={12} display={"flex"}>
                      <Box
                        display={"flex"}
                        className={classes.WarningIconYellow}
                      >
                        <PrimaryIcon
                          width="25px"
                          height="25px"
                          icon={AlertIcon}
                        />
                      </Box>
                    </Grid>
                  )}
                </Grid>
                <Grid
                  xs={10}
                  sm={10}
                  md={10}
                  lg={10}
                  className={classes.rsOrderGapText}
                >
                  {showOrderMedicationDateDetails?.order_gap ? (
                    <Grid
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      display={"flex"}
                      flexDirection={"column"}
                      textAlign={"center"}
                    >
                      <Typography color="secondary" regular variant="h4">
                        {showOrderMedicationDateDetails?.order_gap} Days
                      </Typography>
                      <Typography color="secondary" regular variant="h4">
                        Order Gap
                      </Typography>
                    </Grid>
                  ) : (
                    showOrderMedicationDateDetails?.order_gap === 0 && (
                      <Grid
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        display={"flex"}
                        flexDirection={"column"}
                        textAlign={"center"}
                      >
                        <Typography color="secondary" regular variant="h4">
                          0 Days
                        </Typography>
                        <Typography color="secondary" regular variant="h4">
                          Order Gap
                        </Typography>
                      </Grid>
                    )
                  )}
                </Grid>
              </Grid>
              {(showOrderMedicationDateDetails?.order_gap_status === 1 ||
                showOrderMedicationDateDetails?.order_gap_status === 3) && (
                <Grid>
                  <PrimaryIcon
                    color="primary"
                    width="130px"
                    height="10px"
                    icon={Ellipses}
                    cursor="pointer"
                  />
                </Grid>
              )}
              {showOrderMedicationDateDetails?.order_gap_status === 2 && (
                <Grid>
                  <PrimaryIcon
                    color="primary"
                    width="130px"
                    height="10px"
                    icon={EllipsesYellow}
                    cursor="pointer"
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item className={classes.rsDateDetails} marginLeft={"10px"}>
            <Typography color="secondary" regular variant="h5">
              Medication Date
            </Typography>
            <Typography color="secondary" regular variant="h4">
              {showOrderMedicationDateDetails?.medication_date === null
                ? "-"
                : moment(
                    new Date(showOrderMedicationDateDetails?.medication_date),
                  ).format("DD/MM/YYYY") || "N / A"}
            </Typography>
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default React.memo(RepeatOrderTable);
